import preloadChunks from '@/routes/preloadChunks.util';

// The form is a sibling, not a child: it replaces the whole page (own back
// button, hidden headline), so it must not render through a parent <Outlet/>.
const safeTransferRoutes = [
  {
    path: 'safe-transfer',
    lazy: async () => ({
      Component: (await preloadChunks['safeTransfer.main']()).default,
    }),
  },
  {
    path: 'safe-transfer/:transferId',
    lazy: async () => ({
      Component: (await preloadChunks['safeTransfer.form']()).default,
    }),
  },
];

export default safeTransferRoutes;
